import {sequence, trigger, stagger, animate, style, group, query as q, transition, keyframes, animateChild} from '@angular/animations';
export function query(s, a, o={optional:true}) {
  return q(s,a,o);
}
export const listTransition = trigger('list', [
  transition('* => *', [
    query(':enter', [
      style({ transform: 'scaleY(0.8)', opacity: 0 }),
      stagger(100, [
        animate('.5s cubic-bezier(.8, -0.6, 0.2, 1)',
        style({ transform: 'scaleY(1)', opacity: 1 }))
      ])
    ],{ optional:true })
  ])
])



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/animations/list-animations.ts